export const CONVERSATION_STATUS = {
  new: "Sent to support", acknowledged: "Sent to support", in_progress: "With support",
  reopened: "With support", pending_customer: "Needs your reply", resolved: "Resolved",
  closed: "Closed", discarded: "Closed",
};
export const createRequestId = () => (typeof window !== "undefined" && window.crypto?.randomUUID?.())
  || `support_${Date.now()}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`;
export const sessionIdentity = (session) => session
  ? String(session.id || session.userId || session.email || session.phone || "") : "";
export const emptyDraft = (bookingId = "") => ({
  text: "", bookingId, category: "general", subcategory: "", attachments: [],
  paymentDate: "", paymentTime: "", paymentAmount: "", paymentMethod: "", relatedTicketId: "",
  pending: null, sending: false, error: "", actionId: "",
});
export const safeSupportUrl = (url) => {
  try { const parsed = new URL(url, window.location.origin); return ["https:", "http:"].includes(parsed.protocol) ? parsed.href : ""; }
  catch (_) { return ""; }
};
export const paymentDetailsRequired = (draft) => draft.category === "payment" && draft.subcategory === "amount_debited";
export const draftProblem = (draft) => {
  if (!draft.text.trim()) return "Write a message to continue.";
  if (draft.attachments.some((file) => file.state !== "ready")) return "Finish uploading or remove the files that could not upload.";
  if (paymentDetailsRequired(draft)) {
    if (!draft.paymentDate || !draft.paymentTime || !(Number(draft.paymentAmount) > 0) || !draft.paymentMethod) return "Add the payment date, approximate time, amount and method.";
    if (!draft.attachments.length) return "Attach a payment screenshot or related file.";
  }
  return "";
};
export const draftPayload = (draft, sourceContext) => ({
  subject: draft.text.trim().replace(/\s+/g, " ").slice(0, 100),
  description: draft.text.trim() + (paymentDetailsRequired(draft)
    ? `\n\nPayment details\nDate: ${draft.paymentDate}\nApproximate time: ${draft.paymentTime}\nAmount: INR ${draft.paymentAmount}\nMethod: ${draft.paymentMethod}` : ""),
  category: draft.category, subcategory: draft.subcategory, priority: "normal",
  bookingId: draft.bookingId, sourceContext,
  ...(draft.relatedTicketId ? { relatedTicketId: draft.relatedTicketId } : {}),
  attachments: draft.attachments.map((entry) => entry.uploaded),
});
export const conversationMessages = (ticket) => {
  if (!ticket) return [];
  const messages = ticket.description || ticket.attachments?.length ? [{
    id: `${ticket.id}-opening`, role: "customer", message: ticket.description,
    attachments: ticket.attachments || [], createdAt: ticket.createdAt,
  }] : [];
  for (const [index, entry] of (ticket.timeline || []).entries()) {
    if (entry.visibility === "internal") continue;
    if (entry.type === "ticket_created") {
      if (messages[0]) Object.assign(messages[0], { bookingAttachments: entry.bookingAttachments, receiptAttachments: entry.receiptAttachments });
      continue;
    }
    messages.push({ ...entry, id: entry.id || `${ticket.id}-${index}`,
      role: entry.type === "customer_reply" ? "customer" : entry.type === "public_reply" ? "support" : "system" });
  }
  return messages.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));
};
export const formatConversationDate = (value, timeOnly = false) => {
  if (!value || Number.isNaN(new Date(value).getTime())) return "";
  return new Intl.DateTimeFormat("en-IN", timeOnly ? { hour: "numeric", minute: "2-digit" } : { day: "numeric", month: "short", year: "numeric" }).format(new Date(value));
};
